export default __webpack_public_path__ + "610efd0b92391705a74ed230696c2169.png";